import L from "leaflet";
import umkmIcon from "../assets/images/peta/icon-umkm.png";
import request from "./request";

const MEASUREOPTIONS = {
  position: "topright",
  primaryLengthUnit: "meters",
  secondaryLengthUnit: "kilometers",
  primaryAreaUnit: "sqmeters",
  secondaryAreaUnit: "acres",
  activeColor: "#db4a29",
  completedColor: "#9b2d14",
  color: "#6C757D",
};

const JENIS_LISTRIK = [
  {
    id: 1,
    name: "Prabayar",
    value: "prabayar",
  },
  {
    id: 2,
    name: "Pascabayar",
    value: "pascabayar",
  },
];

const ACTION_LEGENDA = [
  {
    label: "Tambah",
    value: "create",
  },
  {
    label: "Ubah",
    value: "edit",
  },
];

const OPSI_LEGENDA = [
  {
    label: "Manual",
    value: "manual",
  },
  {
    label: "Satu legenda",
    value: "one_legenda",
  },
];

const TIPE_LEGENDA = [
  {
    label: "Warna",
    value: "warna",
  },
  {
    label: "Icon",
    value: "icon",
  },
];

const DUMMYLIST_SKAU = (id = 1) => {
  return {
    tempId: id,
    name: "daftar_kayu",
    input: [
      {
        label: "Jenis",
        name: "jenis",
        required: true,
        errorMessage: "Masukkan jenis",
        type: "text",
        valueAsNumber: false,
      },
      {
        label: "Jumlah",
        name: "jumlah",
        required: true,
        errorMessage: "Masukkan jumlah",
        type: "number",
        valueAsNumber: true,
      },
      {
        label: "Panjang",
        name: "panjang",
        required: true,
        errorMessage: "Masukkan panjang",
        type: "number",
        valueAsNumber: false,
      },
      {
        label: "Lebar",
        name: "lebar",
        required: true,
        errorMessage: "Masukkan lebar",
        type: "number",
        valueAsNumber: false,
      },
      {
        label: "Tebal",
        name: "tebal",
        required: true,
        errorMessage: "Masukkan tebal",
        type: "number",
        valueAsNumber: false,
      },
    ],
  };
};

const DUMMY_LIST_AHLI_WARIS = (id = 1) => {
  return {
    tempId: id,
    name: "ahli_waris",
    input: [
      {
        label: "Nama",
        name: "nama",
        required: true,
        errorMessage: "Masukkan nama",
        type: "text",
      },
      {
        label: "Umur",
        name: "umur",
        required: true,
        errorMessage: "Masukkan umur",
        type: "number",
        valueAsNumber: true,
      },
    ],
  };
};

const DUMMY_LIST_BAGI_WARISAN = (id = 1) => {
  return {
    tempId: id,
    name: "pembagian_warisan",
    input: [
      {
        label: "Nama",
        name: "nama",
        required: true,
        errorMessage: "Masukkan nama",
        type: "text",
      },
      {
        label: "Item",
        name: "items",
        required: true,
        errorMessage: "Masukkan item",
        type: "list",
        childs: [
          {
            label: "Nama",
            name: "nama",
            required: true,
            errorMessage: "Masukkan nama",
            type: "text",
          },
          {
            label: "Keterangan",
            name: "keterangan",
            required: true,
            errorMessage: "Masukkan keterangan",
            type: "text",
          },
        ],
      },
    ],
  };
};

const DUMMYLIST_PEMAKAMAN = (id = 1) => {
  return {
    tempId: id,
    name: "item_pemakaman",
    input: [
      {
        label: "Nama",
        name: "nama",
        required: true,
        errorMessage: "Masukkan nama",
        type: "text",
      },
      {
        label: "Volume",
        name: "volume",
        required: true,
        errorMessage: "Masukkan volume",
        type: "number",
        valueAsNumber: true,
      },
      {
        label: "Satuan",
        name: "satuan",
        required: true,
        errorMessage: "Masukkan satuan",
        type: "text",
      },
      {
        label: "Harga",
        name: "harga",
        required: true,
        errorMessage: "Masukkan harga",
        type: "number",
        valueAsNumber: true,
      },
      {
        label: "Keterangan",
        name: "keterangan",
        required: true,
        errorMessage: "Masukkan keterangan",
        type: "textarea",
      },
    ],
  };
};

const DUMMYLIST_SKAW = (id = 1) => {
  return {
    tempId: id,
    name: "ahli_waris",
    input: [
      {
        label: "Nama",
        name: "nama",
        required: true,
        errorMessage: "Masukkan nama",
        type: "text",
      },
      {
        label: "Pekerjaan",
        name: "pekerjaan",
        required: true,
        errorMessage: "Masukkan pekerjaan",
        type: "select",
        getAsync: async (values) => {
          const { data: req } = await request.get(
            `/v1/pekerjaan/?filter{nama.contains}=${values}`
          );

          return req.data.map((el) => ({
            label: el.nama,
            value: el.nama,
          }));
        },
      },
      {
        label: "Umur",
        name: "umur",
        required: true,
        errorMessage: "Masukkan umur",
        type: "number",
      },
      {
        label: "Alamat",
        name: "alamat",
        required: true,
        errorMessage: "Masukkan alamat",
        type: "alamat",
      },
    ],
  };
};

const KELAINAN_FISIK = {
  1: "Ada",
  2: "Tidak Ada",
};

const SELECT_VALUE = {
  NAMA: (item) => ({ label: item.nama, value: item.nama }),
  ID: (item) => ({ label: item.nama, value: item.id }),
  RT: (item) => ({ label: item.rt, value: item.id }),
  RW: (item) => ({ label: item.rw, value: item.id }),
  NIK: (item) => ({ label: item.nik, value: item.nik }),
};

const JENIS_KEPINDAHAN = {
  KEPALA_KELUARGA: 1,
  KEPALA_KELUARGA_DAN_SEMUA_ANGGOTA: 2,
  KEPALA_KELUARGA_DAN_BEBERAPA_ANGGOTA: 3,
  ANGGOTA_KELUARGA: 4,
};

const JENIS_KELAMIN = {
  LAKI_LAKI: "Laki - Laki",
  PEREMPUAN: "Perempuan",
};

const DATA_JENIS_KELAMIN = [
  {
    name: "lakilaki",
    value: JENIS_KELAMIN.LAKI_LAKI,
  },
  { name: "perempuan", value: JENIS_KELAMIN.PEREMPUAN },
];

const BASE_MAP_ZOOM_LEVEL = 15;

const API_BASE_URL = process.env.REACT_APP_API_URL;

const PETA_PER_PAGE = 500;

const DATA_BATAS_DAERAH_NAMA = {
  BIDANG: "Batas Bidang",
  DESA: "Batas Desa",
  DUSUN: "Batas Dusun",
  DUKUH: "Batas Dukuh",
  RW: "Batas RW",
  RT: "Batas RT",
  UMKM: "UMKM",
  PBB: "Pajak Bumi dan Bangunan",
};

const LIST_DATA_LAYER = [
  {
    url: "sigdesa",
    perpage: 1,
    title: DATA_BATAS_DAERAH_NAMA.DESA,
    typeJson: "FeatureCollection",
    checked: true,
    name: "nama_desa",
    type: "desa",
    zoom: 16,
    active: true,
    warna: "#97de95",
    warnaActive: "#4fb783",
    fillOpacityLayer: 0.5,
    weightLayer: 0.8,
    outlineColor: "#FFD571",
  },
  {
    url: "sigdusun",
    perpage: 5,
    typeJson: "FeatureCollection",
    title: DATA_BATAS_DAERAH_NAMA.DUSUN,
    checked: false,
    name: "nama_dusun",
    type: "desa",
    zoom: 16,
    active: true,
    warna: "#52057b",
    warnaActive: "#b42ffa",
    fillOpacityLayer: 0.5,
    weightLayer: 0.8,
    outlineColor: "#FFD571",
  },
  {
    url: "sigdukuh",
    perpage: 11,
    typeJson: "FeatureCollection",
    title: DATA_BATAS_DAERAH_NAMA.DUKUH,
    checked: false,
    name: "nama_dukuh",
    type: "dukuh",
    zoom: 16,
    active: true,
    warna: "#5b6d5b",
    warnaActive: "#025955",
    fillOpacityLayer: 0.6,
    weightLayer: 0.8,
    outlineColor: "#FFD571",
  },
  {
    url: "sigrw",
    perpage: 10,
    typeJson: "FeatureCollection",
    title: DATA_BATAS_DAERAH_NAMA.RW,
    checked: false,
    name: "rw",
    zoom: 16,
    active: true,
    warna: "#ffd34f",
    warnaActive: "#faaf5f",
    fillOpacityLayer: 0.5,
    weightLayer: 0.8,
    outlineColor: "#FFD571",
  },
  {
    url: "sigrt",
    perpage: 23,
    typeJson: "FeatureCollection",
    title: DATA_BATAS_DAERAH_NAMA.RT,
    checked: false,
    name: "rt",
    zoom: 16,
    active: true,
    warna: "#7ab7ff",
    warnaActive: "#828bff",
    fillOpacityLayer: 0.5,
    weightLayer: 0.8,
    outlineColor: "#FFD571",
  },
  {
    url: "sigbidang",
    perpage: 1577,
    typeJson: "FeatureCollection",
    title: DATA_BATAS_DAERAH_NAMA.BIDANG,
    checked: false,
    type: "bidang",
    name: "id",
    first_name: "NBT",
    zoom: 20,
    active: true,
    warna: "#FFD571",
    warnaActive: "#FFD571",
    fillOpacityLayer: 0,
    weightLayer: 1.3,
    outlineColor: "#FFD571",
  },
  {
    url: "sigumkm",
    perpage: 40,
    typeJson: "FeatureCollection",
    title: DATA_BATAS_DAERAH_NAMA.UMKM,
    checked: false,
    type: "umkm",
    name: "nama_usaha",
    zoom: 20,
    active: true,
    warna: "#FFD571",
    warnaActive: "#FFD571",
    fillOpacityLayer: 0,
    outlineColor: "#FFD571",
    icon: L.icon({
      iconUrl: umkmIcon,
      iconSize: [30, 30],
    }),
  },
  {
    url: "sigpajak",
    perpage: 1577,
    typeJson: "FeatureCollection",
    title: DATA_BATAS_DAERAH_NAMA.PBB,
    checked: false,
    type: "PBB",
    name: "id",
    zoom: 19,
    active: true,
    warna: "#FFD571",
    warnaActive: "#BBDFC8",
    fillOpacityLayer: 0.8,
    weightLayer: 0.8,
    outlineColor: "#000000",
  },
];

const ACTIVE_LAYER = LIST_DATA_LAYER.filter((item) => item.active === true);

const DATA_BATAS_DAERAH = Object.entries(DATA_BATAS_DAERAH_NAMA).reduce(
  (prev, current) => {
    prev[current[0]] = {
      name: ACTIVE_LAYER.find((item) => item.title === current[1])?.title,
      index: ACTIVE_LAYER.findIndex((item) => item.title === current[1]),
    };
    return prev;
  },
  {}
);

const DONUT_OPTIONS = {
  legend: {
    show: false,
  },
  chart: {
    animations: {
      enabled: true,
      easing: "easeinout",
      speed: 800,
      animateGradually: {
        enabled: true,
        delay: 150,
      },
      dynamicAnimation: {
        enabled: true,
        speed: 350,
      },
    },
  },
};

const BAR_OPTIONS = {
  chart: {
    type: "bar",
    height: 350,
  },
  legend: {
    show: false,
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "55%",
      endingShape: "rounded",
      distributed: true,
    },
  },
  theme: {
    palette: "palette1",
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    show: true,
    width: 5,
  },
  fill: {
    opacity: 1,
  },
};

const SELECT_OPTIONS = [
  {
    label: "Pekerjaan",
    value: "pekerjaan",
  },
  {
    label: "Pendidikan",
    value: "pendidikan",
  },
  {
    label: "Potensi Diri",
    value: "potensi_diri",
  },
  {
    label: "Kepadatan",
    value: "kepadatan",
  },
  {
    label: "MBR",
    value: "mbr",
  },
  {
    label: "Penghasilan",
    value: "penghasilan",
  },
];

const MDE_OPTIONS = {
  options: {
    autosave: {
      enabled: false,
      uniqueId: 1,
      delay: 1000,
    },
    toolbar: [
      "bold",
      "italic",
      "heading",
      "|",
      "unordered-list",
      "ordered-list",
      "link",
      "preview",
    ],
  },
};

const ROLES = {
  ADMIN_DESA: "admindesa",
  KEPALADESA: "kepaladesa",
  SEKRETARIS: "sekretaris",
  KASIPEMERINTAHAN: "kasipemerintahan",
  KASILAYANAN: "kasilayanan",
  KAURKEUANGAN: "kaurkeuangan",
  KAURUMUM: "kaur_umum",
  KAURPERENCANAAN: "kaurperencanaan",
  KADUS: "kadus",
};

const SETTINGS_MDE = {
  options: {
    autosave: {
      enabled: false,
      uniqueId: 1,
      delay: 1000,
    },
    toolbar: [
      "bold",
      "italic",
      "heading",
      "|",
      "unordered-list",
      "ordered-list",
      "link",
      "preview",
    ],
  },
};

const REMOVE_USELESS_KEY = [
  "id",
  "created_at",
  "updated_at",
  "deleted_at",
  "links",
  "pass_field",
  "created_by",
  "updated_by",
  "deleted_by",
  "user",
  "desa",
  "penduduk",
  "deleted",
];

const BIDANG_LAYER = {
  BIDANG: "bidanglayer",
  COVID: "covidlayer",
};

const TIPE_PETA = {
  BIDANG: "bidang",
  COVID: "covid",
  VAKSIN: "vaksin",
  STUNTING: "stunting",
  BANSOS: "bansos",
  BLT: "blt",
  PKH: "pkh",
  DASAR: "dasar",
  TEMATIK: "tematik",
  PEMBANGUNAN: "pembangunan",
};

const FEATURE_PETA_TEMATIK = [
  {
    label: "Covid",
    value: "covid",
  },
  {
    label: "Vaksin",
    value: "vaksin",
  },
  {
    label: "BLT (Bantuan Langsung Tunai)",
    value: "blt",
  },
  {
    label: "PKH (Program Keluarga Harapan)",
    value: "pkh",
  },
  {
    label: "BANSOS (Bantuan Sosial)",
    value: "bansos ",
  },
  {
    label: "Stunting",
    value: "stunting",
  },
  {
    label: "Pembangunan",
    value: "pembangunan",
  },
  {
    label: "Pemanfaatan Tanah",
    value: "pemanfaatan_tanah",
  },
  {
    label: "Lainnya",
    value: "others",
  },
];

const TIPE_WITH_BIDANG = [
  "covid",
  "vaksin",
  "blt",
  "pkh",
  "bansos",
  "stunting",
];

const HIERARKI_CASE = {
  ONE: "1",
  TWO: "2",
  THREE: "3",
  FOUR: "4",
};

const TIPE_LAYER = {
  POINT: "Point",
  LINE_STRING: "LineString",
  POLYGON: "Polygon",
  POLYLINE: "Polyline",
};

const FIELD_MAPS_WITH_LAYER_BIDANG = [
  {
    TIPE: "vaksin",
    FIELD: "jumlah_vaksin",
    COLOR_CHART: ["#FF0000", "#00A19D"],
    LABEL_CHART: ["Belum Vaksin", "Sudah Vaksin"],
    DESKRIPSI_ALERT:
      "Data dibawah ini adalah data nomor kk dan kepala keluarga yang sudah vaksin",
    TOOLTIP_MAPS: "Jumlah yang sudah vaksin",
    TOOLTIP_WHOLE: "Jumlah yang sudah vaksin di desa",
    NEGATIVE_COLOR: "#FF0000",
    POSITIVE_COLOR: "#00A19D",
  },
  {
    TIPE: "covid",
    FIELD: "jumlah_covid",
    COLOR_CHART: ["#79B59D", "#D52840"],
    LABEL_CHART: ["Negatif Covid", "Positif Covid"],
    DESKRIPSI_ALERT:
      "Data dibawah ini adalah data nomor kk dan kepala keluarga yang terpapar covid",
    TOOLTIP_MAPS: "Jumlah yang terpapar covid",
    TOOLTIP_WHOLE: "Jumlah yang terpapar covid di desa",
    NEGATIVE_COLOR: "#79B59D",
    POSITIVE_COLOR: "#D52840",
  },
  {
    TIPE: "stunting",
    FIELD: "jumlah_stunting",
    COLOR_CHART: ["#F037A5", "#1E3163"],
    LABEL_CHART: ["Bukan penderita", "Penderita"],
    DESKRIPSI_ALERT:
      "Data dibawah ini adalah data nomor kk dan kepala keluarga yang penderita stunting",
    TOOLTIP_MAPS: "Jumlah yang menderita penyakit stunting",
    TOOLTIP_WHOLE: "Jumlah yang menderita penyakit stunting di desa",
    NEGATIVE_COLOR: "#F037A5",
    POSITIVE_COLOR: "#1E3163",
  },
  {
    TIPE: "pkh",
    FIELD: "jumlah_pkh",
    COLOR_CHART: ["#C36839", "#7EB5A6"],
    LABEL_CHART: ["Bukan penerima", "Penerima"],
    DESKRIPSI_ALERT:
      "Data dibawah ini adalah data nomor kk dan kepala keluarga yang penerima pkh",
    TOOLTIP_MAPS: "Jumlah penerima bantuan pkh",
    TOOLTIP_WHOLE: "Jumlah penerima bantuan pkh di desa",
    NEGATIVE_COLOR: "#C36839",
    POSITIVE_COLOR: "#7EB5A6",
  },
  {
    TIPE: "blt",
    FIELD: "jumlah_blt",
    COLOR_CHART: ["#FFEDDA", "#3DB2FF"],
    LABEL_CHART: ["Bukan penerima", "Penerima"],
    DESKRIPSI_ALERT:
      "Data dibawah ini adalah data nomor kk dan kepala keluarga yang penerima blt",
    TOOLTIP_MAPS: "Jumlah penerima bantuan blt",
    TOOLTIP_WHOLE: "Jumlah penerima bantuan di desa",
    NEGATIVE_COLOR: "#FFEDDA",
    POSITIVE_COLOR: "#3DB2FF",
  },
  {
    TIPE: "bansos",
    FIELD: "jumlah_bansos",
    COLOR_CHART: ["#DF2E2E", "#F6D167"],
    LABEL_CHART: ["Bukan penerima", "Penerima"],
    DESKRIPSI_ALERT:
      "Data dibawah ini adalah data nomor kk dan kepala keluarga yang penerima bansos",
    TOOLTIP_MAPS: "Jumlah penerima bantuan bansos",
    TOOLTIP_WHOLE: "Jumlah penerima bantuan bansos di desa",
    NEGATIVE_COLOR: "#DF2E2E",
    POSITIVE_COLOR: "#F6D167",
  },
];

let CONFIG_CHART = {
  appendPadding: 10,
  angleField: "y",
  colorField: "name",
  radius: 0.75,
  label: {
    type: "spider",
    labelHeight: 28,
    content: "{name}\n{percentage}",
  },
  legend: "bottom",
  interactions: [{ type: "element-selected" }, { type: "element-active" }],
};

const TIPE_HERO = {
  SLIDER: 1,
  DUA_GAMBAR: 2,
};

const CK_EDITOR_TOOLBAR_GROUP = [
  { name: "document", groups: ["mode", "document", "doctools"] },
  { name: "clipboard", groups: ["clipboard", "undo"] },
  { name: "editing", groups: ["find", "selection", "spellchecker", "editing"] },
  { name: "forms", groups: ["forms"] },
  "/",
  { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
  {
    name: "paragraph",
    groups: ["list", "indent", "blocks", "align", "bidi", "paragraph"],
  },
  { name: "links", groups: ["links"] },
  { name: "insert", groups: ["insert"] },
  "/",
  { name: "styles", groups: ["styles"] },
  { name: "colors", groups: ["colors"] },
  { name: "tools", groups: ["tools"] },
  { name: "others", groups: ["others"] },
  { name: "about", groups: ["about"] },
];

const SUB_MENU_PPID = {
  LIST: [
    {
      label: "Ya",
      value: "ya",
    },
    {
      label: "Tidak",
      value: "tidak",
    },
  ],
  CHOOSE: {
    YA: "ya",
    TIDAK: "tidak",
  },
};

const DUMMY_LIST_SUBMENU_PPID = (id = 1) => {
  return {
    tempId: id,
    name: "sub_menu",
    input: [
      {
        label: "Nama",
        name: "nama",
        required: true,
        errorMessage: "Masukkan nama",
        type: "text",
      },
      {
        label: "Path",
        name: "path",
        required: true,
        errorMessage: "Masukkan path",
        type: "text",
      },
      {
        label: "Isi",
        name: "isi",
        required: true,
        errorMessage: "Masukkan path",
        type: "editor",
      },
    ],
  };
};

const HTTP_METHOD = {
  POST: "post",
  GET: "get",
  PUT: "put",
  PATCH: "patch",
  DELETE: "delete",
};

const LOADING_TEXT = {
  GET: "memuat data...",
  POST: "menambahkan data...",
  PUT: "mengubah data...",
};

const BASE_MAP = {
  GOOGLEMAP: "googlemap",
  GOOGLESATELITE: "googlesatelite",
};

const CHOOSE_INTEGRASI_BIDANG = [
  {
    label: "Warga",
    value: "warga",
  },
  {
    label: "Non Warga",
    value: "non-warga",
  },
];

const CHOOSE_PENGGUNAAN_TANAH = {
  CAMPURAN: "campuran",
  PERTANIAN: "pertanian",
  NON_PERTANIAN: "non pertanian",
  SELECT: [
    {
      label: "Pertanian",
      value: "pertanian",
    },
    {
      label: "Non Pertanian",
      value: "non pertanian",
    },
    {
      label: "Campuran",
      value: "campuran",
    },
  ],
};

const STATUS_UPLOADING = {
  PENDING: "PENDING",
  PROGRESS: "PROGRESS",
  SUCCESS: "SUCCESS",
};

const NOTIF_KEY = {
  LAPOR: "lapor",
  LAYANAN: "layanan",
  POTENSI: "potensi",
};

const TYPE_LEGEND = {
  COLOR: "color",
  ICON: "icon",
};

const INITIAL_LEGENDA = {
  DASAR: [
    {
      ket_color: "desa",
      warna: "#90B8D7",
      color: "#FFFFFF",
      fillColor: "#90B8D7",
      fillOpacity: 0.8,
      weight: 0.8,
    },
    {
      ket_color: "subdesa",
      warna: "#BFE5FF",
      color: "#FFFFFF",
      fillColor: "#BFE5FF",
      fillOpacity: 0.8,
      weight: 0.8,
    },
    {
      ket_color: "subsubdesa",
      warna: "#FDF9B5",
      color: "#FFFFFF",
      fillColor: "#FDF9B5",
      fillOpacity: 0.8,
      weight: 0.8,
    },
    {
      ket_color: "rw",
      warna: "#FCB2BC",
      color: "#FFFFFF",
      fillColor: "#FCB2BC",
      fillOpacity: 0.8,
      weight: 0.8,
    },
    {
      ket_color: "rt",
      warna: "#DAB3FC",
      color: "#FFFFFF",
      fillColor: "#DAB3FC",
      fillOpacity: 0.8,
      weight: 0.8,
    },
    {
      ket_color: "bidang",
      warna: "#B0FFC5",
      color: "#FFFFFF",
      fillColor: "#B0FFC5",
      fillOpacity: 0.8,
      weight: 0.8,
    },
  ],
  TEMATIK: [
    {
      warna: "#B1BDFF",
      ket_color: "Pemanfaatan Tanah",
      nama: "pemanfaatan_tanah",
    },
    { warna: "#79B59D", ket_color: "Negatif Covid", nama: "covid" },
    { warna: "#D52840", ket_color: "Positif Covid", nama: "covid" },
    { warna: "#00A19D", ket_color: "Sudah Vaksin", nama: "vaksin" },
    { warna: "#FF0000", ket_color: "Belum Vaksin", nama: "vaksin" },
    { warna: "#1E3163", ket_color: "Penderita Stunting", nama: "stunting" },
    {
      warna: "#F037A5",
      ket_color: "Bukan Penderita Stunting",
      nama: "stunting",
    },
    { warna: "#7EB5A6", ket_color: "Penerima PKH", nama: "pkh" },
    { warna: "#C36839", ket_color: "Bukan Penerima PKH", nama: "pkh" },
    { warna: "#3DB2FF", ket_color: "Penerima BLT", nama: "blt" },
    { warna: "#FFEDDA", ket_color: "Bukan Penerima BLT", nama: "blt" },
    { warna: "#F6D167", ket_color: "Penerima Bansos", nama: "bansos" },
    { warna: "#DF2E2E", ket_color: "Bukan Penerima Bansos", nama: "bansos" },
  ],
  INTEGRATION: {
    LIST: [
      { warna: "#79B59D", ket_warna: "Terintegrasi" },
      { warna: "#F6FF00", ket_warna: "Belum Lengkap" },
      { warna: "#D52840", ket_warna: "Belum Terintegrasi" },
    ],
    TERINTEGRASI: { fillColor: "#79B59D" },
    BELUM_LENGKAP: { fillColor: "#F6FF00" },
    BELUM_TERINTEGRASI: { fillColor: "#D52840" },
  },
};

const JENIS_PETA = {
  DASAR: "peta_dasar",
  TEMATIK: "peta_tematik",
  OTHERS: "others",
};

const OPTION_SEARCH_PENGUASA = {
  NAMA: "nama",
  NO_KK: "no_kk",
  SELECT: [
    {
      label: "Nama",
      value: "nama",
    },
    {
      label: "Nomor Kartu Keluarga",
      value: "no_kk",
    },
  ],
};

const STATUS_HAK = {
  LIST: [
    {
      label: "Hak Milik",
      value: "hak milik",
    },
    {
      label: "Hak Guna Bangunan",
      value: "hak guna bangunan",
    },
    {
      label: "Hak Pakai",
      value: "hak pakai",
    },
    {
      label: "Hak Pengelolaan",
      value: "hak pengelolaan",
    },
    {
      label: "Hak Guna Usaha",
      value: "hak guna usaha",
    },
    {
      label: "Belum Sertipikat",
      value: "belum sertipikat",
    },
  ],
};

const CREATE_TIPE_METODE = {
  UPLOAD: "upload",
  CREATE: "create",
  USE: "use",
  SELECT: [
    {
      label: "Upload GeoJSON",
      value: "upload",
    },
    {
      label: "Membuat Peta Sendiri",
      value: "create",
    },
    {
      label: "Menggunakan Peta Yang Sudah Ada",
      value: "use",
    },
  ],
};

const SIG_WITH_RELATIONS = {
  BIDANG: "bidang",
  SELECT: [
    {
      label: "Bidang",
      value: "bidang",
    },
  ],
};

const DATA_WITH_SIG_RELATIONS = {
  PENDUDUK: "penduduk",
  KELUARGA: "keluarga",
  SELECT: [
    {
      label: "Keluarga",
      value: "keluarga",
    },
    {
      label: "Penduduk",
      value: "penduduk",
    },
  ],
};

const HIERARKI_MODEL = {
  DESA: "desa",
  SUBDESA: "subdesa",
  SUBSUBDESA: "subsubdesa",
  RW: "rw",
  RT: "rt",
  BIDANG: "bidang",
};

const GEOJSON_STYLES = [
  "stroke",
  "color",
  "weight",
  "opacity",
  "lineCap",
  "lineJoin",
  "dashArray",
  "dashOffset",
  "fill",
  "fillColor",
  "fillOpacity",
  "fillRule",
  "bubblingMouseEvents",
];

const HIERARKI_CASE_NAME = {
  ALL: "all",
  SUBDESA_SUBSUBDESA_RW: "subdesa_subsubdesa_rw",
  SUBDESA_SUBSUBDESA_RT: "subdesa_subsubdesa_rt",
  SUBDESA_RW_RT: "subdesa_rw_rt",
  SUBDESA_SUBSUBDESA: "subdesa_subsubdesa",
  SUBDESA_RW: "subdesa_rw",
  SUBDESA_RT: "subdesa_rt",
  SUBDESA: "subdesa",
};

const PALLETE_STYLES = [
  "white",
  "red",
  "darkred",
  "orange",
  "green",
  "darkgreen",
  "lightgreen",
  "blue",
  "darkblue",
  "lightblue",
  "purple",
  "pink",
  "cadetblue",
  "gray",
  "lightgray",
  "black",
  "white",
  "red",
  "darkred",
  "orange",
  "green",
  "darkgreen",
  "lightgreen",
  "blue",
  "darkblue",
  "lightblue",
  "purple",
  "darkpurple",
  "pink",
  "cadetblue",
  "gray",
  "lightgray",
  "black",
  "white",
  "red",
  "darkred",
  "orange",
  "green",
  "darkgreen",
  "lightgreen",
  "blue",
  "darkblue",
  "lightblue",
  "purple",
  "darkpurple",
  "pink",
  "cadetblue",
  "gray",
  "lightgray",
  "black",
  "white",
  "red",
  "darkred",
  "orange",
  "green",
  "darkgreen",
  "lightgreen",
  "blue",
  "darkblue",
  "lightblue",
  "purple",
  "darkpurple",
  "pink",
  "cadetblue",
  "gray",
  "lightgray",
  "black",
  "white",
  "red",
  "darkred",
  "orange",
  "green",
  "darkgreen",
  "lightgreen",
  "blue",
  "darkblue",
  "lightblue",
  "purple",
  "darkpurple",
  "pink",
  "cadetblue",
  "gray",
  "lightgray",
  "black",
];

const LEGEND_KEY = ["ket_color", "ket_icon", "warna", "icon"];

const PROPERTIES_DRAW_MAP = [
  "leafletID",
  "klasifikasi_atribut",
  "klasifikasi_atribut_name",
  "id",
];

const GEOJSON_STYLES_WITH_LAYER_BIDANG = {
  ACTIVE: {
    color: "red",
    weight: 0.5,
    fillColor: "red",
  },
  INACTIVE: {
    fillColor: "blue",
    weight: 0.5,
  },
};

const DEFAULT_GEOJSON_STYLES = {
  POINT: {},
  OTHER_THAN_POINT: {
    fillColor: "#ff6b79",
    fillOpacity: 1,
    color: "#fff",
    weight: 0.8,
  },
  OTHER_THAN_POINT_NO_FILLCOLOR: {
    fillOpacity: 1,
    color: "#fff",
    weight: 0.8,
    fillColor: "transparent",
  },
  OTHER_THAN_POINT_WITH_FILL_COLOR: {
    fillOpacity: 1,
    color: "#000",
    weight: 0.8,
  },
  NO_STYLES: {
    fillColor: "transparent",
    color: "transparent",
    weight: 0,
  },
  DRAW_STYLES: {
    fillColor: "#6bd3ff",
    fillOpacity: 0.4,
    color: "#000000",
    weight: 1.3,
  },
  ACTIVE: {
    color: "#000000",
    weight: 1.3,
  },
};

const TYPE_ORTU = {
  WARGA: "warga",
  NON_WARGA: "non_warga",
  TIDAK_DIKETAHUI: "tidak_diketahui",
  LISTS: [
    {
      label: "WARGA",
      value: "warga",
    },
    {
      label: "NON WARGA",
      value: "non_warga",
    },
    {
      label: "TIDAK DIKETAHUI",
      value: "tidak_diketahui",
    },
  ],
};

const HOLLOW_MAP_STYLE = {
  color: "red",
  fillColor: "transparent",
  fillOpacity: 0,
  weight: 0.8,
};

const PASSWORD_SYMBOL = [
  "!",
  "@",
  "#",
  "$",
  "%",
  "^",
  "&",
  "*",
  "(",
  ")",
  "-",
  "_",
  "+",
  "=",
  "~",
  ",",
  "`",
  "/",
  "|",
  "[",
  "]",
  "{",
  "}",
  ":",
  ";",
  "<",
  ">",
  "?",
  ".",
  "'",
];

const TIPE_PENGUASA = {
  PENDUDUK_WARGA: "pendudukwarga",
  PENDUDUK_NON_WARGA: "penduduknonwarga",
  KELUARGA_WARGA: "keluargawarga",
  KELUARGA_NON_WARGA: "keluarganonwarga",
  LAINNYA: "lainnya",
  LISTS: [
    {
      label: "Penduduk Warga",
      value: "pendudukwarga",
      uri: "/v1/penduduk",
    },
    {
      label: "Penduduk Non Warga",
      value: "penduduknonwarga",
      uri: "/v1/penguasanonwarga",
    },
    {
      label: "Keluarga Warga",
      value: "keluargawarga",
      uri: "/v1/keluarga",
    },
    {
      label: "Keluarga Non Warga",
      value: "keluarganonwarga",
      uri: "/v1/penguasanonwarga",
    },
    {
      label: "Lainnya",
      value: "lainnya",
    },
  ],
};

const PEMANFAATAN_TANAH = {
  pertanian: [
    { label: "Sawah Irigasi", value: "sawah irigasi" },
    { label: "Sawah Non Irigasi", value: "sawah non irigasi" },
    { label: "Tegalan/Ladang", value: "tegalan/ladang" },
    { label: "Sayuran", value: "sayuran" },
    { label: "Bunga-Bungaan", value: "bunga-bungaan" },
    { label: "Kebun Buah", value: "kebun buah" },
    { label: "Kebun Tanaman Hias", value: "kebun tanaman hias" },
    { label: "Kebun Tanaman Obat", value: "kebun tanaman obat" },
    { label: "Kebun Tanaman Keras", value: "kebun tanaman keras" },
    { label: "Kebun Tanaman Semusim", value: "kebun tanaman semusim" },
    { label: "Kebun Campuran", value: "kebun campuran" },
    { label: "Kebun Lainnya", value: "kebun lainnya" },
    { label: "Perkebunan Tanaman Keras", value: "perkebunan tanaman keras" },
    {
      label: "Perkebunan Tanaman Semusim",
      value: "perkebunan tanaman semusim",
    },
    { label: "Peternakan Unggas", value: "peternakan unggas" },
    { label: "Peternakan Non Unggas", value: "peternakan non unggas" },
    { label: "Peternakan Campuran", value: "peternakan campuran" },
    { label: "Peternakan Lainnya", value: "peternakan lainnya" },
    { label: "Padang Rumput", value: "padang rumput" },
    { label: "Semak", value: "semak" },
    { label: "Rawa", value: "rawa" },
    { label: "Hutan Lebat", value: "hutan lebat" },
    { label: "Hutan Belukar", value: "hutan belukar" },
    { label: "Hutan Sejenis", value: "hutan sejenis" },
    { label: "Hutan Lahan Basah", value: "hutan lahan basah" },
    { label: "Hutan Lainnya", value: "hutan lainnya" },
    { label: "Kolam", value: "kolam" },
    { label: "Tambak", value: "tambak" },
    { label: "Penggaraman", value: "penggaraman" },
    { label: "Danau/Telaga", value: "danau/telaga" },
    { label: "Waduk/Situ/Embung", value: "waduk/situ/embung" },
    { label: "Sungai", value: "sungai" },
    { label: "Saluran", value: "saluran" },
  ],
  "non pertanian": [
    { label: "Kampung", value: "kampung" },
    { label: "Perumahan", value: "perumahan" },
    { label: "Sarana Olahraga", value: "sarana olahraga" },
    { label: "Makam/Kuburan", value: "makam/kuburan" },
    { label: "Taman", value: "taman" },
    { label: "Tempat Bersejarah", value: "tempat bersejarah" },
    {
      label: "Industri Pengolahan dan Pengawetan Daging",
      value: "industri pengolahan dan pengawetan daging",
    },
    {
      label: "Industri Pengolahan dan Pengawetan Ikan dan Biota Air",
      value: "industri pengolahan dan pengawetan ikan dan biota air",
    },
    {
      label: "Industri Pengolahan dan Pengawetan Buah dan Sayuran",
      value: "industri pengolahan dan pengawetan buah dan sayuran",
    },
    {
      label: "Industri Minyak Nabati dan Hewani",
      value: "industri minyak nabati dan hewani",
    },
    { label: "Industri Pengolahan Susu", value: "industri pengolahan susu" },
    {
      label: "Industri Penggilingan Padi-padian, Tepung, dan Pati",
      value: "industri penggilingan padi-padian, tepung, dan pati",
    },
    { label: "Industri Makanan Lainnya", value: "industri makanan lainnya" },
    { label: "Industri Makanan Hewan", value: "industri makanan hewan" },
    { label: "Industri Minuman", value: "industri minuman" },
    {
      label: "Industri Pengolahan Tembakau",
      value: "industri pengolahan tembakau",
    },
    { label: "Industri Tekstil", value: "industri tekstil" },
    { label: "Industri Pakaian Jadi", value: "industri pakaian jadi" },
    { label: "Industri Kulit", value: "industri kulit" },
    { label: "Industri Alas Kaki", value: "industri alas kaki" },
    {
      label:
        "Industri Penggergajian dan Pengawetan Kayu, Rotan, Bambu, dan Sejenisnya",
      value:
        "industri penggergajian dan pengawetan kayu, rotan, bambu, dan sejenisnya",
    },
    {
      label:
        "Industri Barang Lainnya dari Kayu; Industri Barang dari Gabus dan Barang Anyaman dari Jerami, Rotan, Bambu, dan Sejenisnya",
      value:
        "industri barang lainnya dari kayu; industri barang dari gabus dan barang anyaman dari jerami, rotan, bambu, dan sejenisnya",
    },
    {
      label: "Industri Kertas dan Barang dari Kertas",
      value: "industri kertas dan barang dari kertas",
    },
    { label: "Industri Percetakan", value: "industri percetakan" },
    { label: "Industri Produk Batu Bara", value: "industri produk batu bara" },
    {
      label: "Industri Produk Pengilangan Minyak Bumi",
      value: "industri produk pengilangan minyak bumi",
    },
    { label: "Industri Bahan Kimia", value: "industri bahan kimia" },
    {
      label: "Industri Barang Kimia Lainnya",
      value: "industri barang kimia lainnya",
    },
    { label: "Industri Serat Buatan", value: "industri serat buatan" },
    {
      label: "Industri Farmasi, Produk Obat Kimia dan Obat Tradisional",
      value: "industri farmasi, produk obat kimia dan obat tradisional",
    },
    {
      label: "Industri Karet dan Barang dari Karet",
      value: "industri karet dan barang dari karet",
    },
    {
      label: "Industri Barang dari Plastik",
      value: "industri barang dari plastik",
    },
    {
      label: "Industri Kaca dan Barang dari Kaca",
      value: "industri kaca dan barang dari kaca",
    },
    {
      label: "Industri Barang Galian Bukan Logam Lainnya",
      value: "industri barang galian bukan logam lainnya",
    },
    {
      label: "Industri Logam Dasar Besi dan Baja",
      value: "industri logam dasar besi dan baja",
    },
    {
      label: "Industri Logam Dasar Mulia dan Logam Dasar Bukan Besi Lainnya",
      value: "industri logam dasar mulia dan logam dasar bukan besi lainnya",
    },
    { label: "Industri Pengecoran Logam", value: "industri pengecoran logam" },
    {
      label:
        "Industri Barang Logam Siap Pasang Untuk Bangunan, Tangki, Tandon Air dan Generator Uap",
      value:
        "industri barang logam siap pasang untuk bangunan, tangki, tandon air dan generator uap",
    },
    {
      label: "Industri Senjata dan Amunisi",
      value: "industri senjata dan amunisi",
    },
    {
      label: "Industri Barang Logam Lainnya dan Jasa Pembuatan Barang Logam",
      value: "industri barang logam lainnya dan jasa pembuatan barang logam",
    },
    {
      label: "Industri Komponen dan Papan Elektronik",
      value: "industri komponen dan papan elektronik",
    },
    {
      label: "Industri Komputer dan Perlengkapannya",
      value: "industri komputer dan perlengkapannya",
    },
    {
      label: "Industri Peralatan Komunikasi",
      value: "industri peralatan komunikasi",
    },
    {
      label: "Industri Peralatan Audio dan Video Elektronik",
      value: "industri peralatan audio dan video elektronik",
    },
    {
      label:
        "Industri Alat Ukur, Alat Uji, Peralatan Navigasi dan Kontrol dan Alat Ukur Waktu",
      value:
        "industri alat ukur, alat uji, peralatan navigasi dan kontrol dan alat ukur waktu",
    },
    {
      label: "Industri Peralatan Iradiasi, Elektromedikal, dan Elektroterapi",
      value: "industri peralatan iradiasi, elektromedikal, dan elektroterapi",
    },
    {
      label: "Industri Peralatan Fotografi",
      value: "industri peralatan fotografi",
    },
    {
      label: "Industri Media Magnetik dan Media Optik",
      value: "industri media magnetik dan media optik",
    },
    {
      label: "Industri Peralatan Listrik",
      value: "industri peralatan listrik",
    },
    {
      label: "Industri Mesin untuk Keperluan Khusus",
      value: "industri mesin untuk keperluan khusus",
    },
    {
      label: "Industri Kendaraan Bermotor, Trailer, dan Semi Trailer",
      value: "industri kendaraan bermotor, trailer, dan semi trailer",
    },
    { label: "Industri Alat Angkutan", value: "industri alat angkutan" },
    { label: "Industri Furniture", value: "industri furniture" },
    {
      label: "Industri Pembuatan Barang Lainnya",
      value: "industri pembuatan barang lainnya",
    },
    { label: "Perbengkelan", value: "perbengkelan" },
    { label: "Pergudangan", value: "pergudangan" },
    { label: "Instalasi", value: "instalasi" },
    {
      label: "Pertambangan Batu Bara dan Lignit",
      value: "pertambangan batu bara dan lignit",
    },
    {
      label: "Pertambangan Minyak Bumi dan Gas Alam",
      value: "pertambangan minyak bumi dan gas alam",
    },
    {
      label: "Pengusahaan Tenaga Panas Bumi",
      value: "pengusahaan tenaga panas bumi",
    },
    {
      label: "Pertambangan Pasir Besi dan Bijih Besi",
      value: "pertambangan pasir besi dan bijih besi",
    },
    {
      label: "Pertambangan Bijih Logam yang Tidak Mengandung Besi",
      value: "pertambangan bijih logam yang tidak mengandung besi",
    },
    {
      label: "Pertambangan Bijih Logam Mulia",
      value: "pertambangan bijih logam mulia",
    },
    {
      label: "Penggalian Batu, Pasir, dan Tanah Liat",
      value: "penggalian batu, pasir, dan tanah liat",
    },
    {
      label: "Pertambangan Mineral, Bahan Kimia dan Bahan Pupuk",
      value: "pertambangan mineral, bahan kimia dan bahan pupuk",
    },
    {
      label: "Ekstraksi Tanah Gemuk (Peat)",
      value: "ekstraksi tanah gemuk (peat)",
    },
    { label: "Ekstraksi Garam", value: "ekstraksi garam" },
    {
      label: "Pertambangan dan Penggalian Lainnya",
      value: "pertambangan dan penggalian lainnya",
    },
    { label: "Penginapan", value: "penginapan" },
    { label: "Tempat Makan", value: "tempat makan" },
    { label: "Tempat Hiburan", value: "tempat hiburan" },
    { label: "Bandar Udara", value: "bandar udara" },
    { label: "Pelabuhan", value: "pelabuhan" },
    { label: "Terminal", value: "terminal" },
    { label: "Stasiun Kereta", value: "stasiun kereta" },
    { label: "Tempat Parkir", value: "tempat parkir" },
    {
      label: "Instansi Pemerintah (Sipil)",
      value: "instansi pemerintah (sipil)",
    },
    { label: "Instansi Militer", value: "instansi militer" },
    { label: "Instansi Kepolisian", value: "instansi kepolisian" },
    { label: "Pendidikan Formal", value: "pendidikan formal" },
    { label: "Pendidikan Informal", value: "pendidikan informal" },
    { label: "Rumah Sakit", value: "rumah sakit" },
    { label: "Puskesmas", value: "puskesmas" },
    { label: "Posyandu", value: "posyandu" },
    { label: "Klinik", value: "klinik" },
    { label: "Balai Pengobatan", value: "balai pengobatan" },
    { label: "Bank", value: "bank" },
    { label: "Non Bank", value: "non bank" },
    { label: "Jasa Profesi Konsultan", value: "jasa profesi konsultan" },
    { label: "Jasa Profesi Notaris", value: "jasa profesi notaris" },
    { label: "Akuntan Publik", value: "akuntan publik" },
    { label: "Apraiser", value: "apraiser" },
    { label: "Surveyor", value: "surveyor" },
    { label: "Salon", value: "salon" },
    { label: "Jasa Profesi Lainnya", value: "jasa profesi lainnya" },
    { label: "Tempat Ibadah Islam", value: "tempat ibadah islam" },
    { label: "Gereja", value: "gereja" },
    { label: "Vihara/Kuil", value: "vihara/kuil" },
    { label: "Pura", value: "pura" },
    { label: "Klenteng", value: "klenteng" },
    { label: "Tempat Ziarah Keagamaan", value: "tempat ziarah keagamaan" },
    { label: "BTS", value: "bts" },
    { label: "Stasiun Telekomunikasi", value: "stasiun telekomunikasi" },
    { label: "TPA Sampah", value: "tpa sampah" },
    {
      label: "Tanah Jasa Kebersihan Lainnya",
      value: "tanah jasa kebersihan lainnya",
    },
    { label: "Pasar", value: "pasar" },
    { label: "Perdagangan Umum", value: "perdagangan umum" },
    { label: "Jalan", value: "jalan" },
    { label: "Jalan Tol", value: "jalan tol" },
    { label: "Tanah Rusak", value: "tanah rusak" },
    { label: "Tanah Terbuka Sementara", value: "tanah terbuka sementara" },
    { label: "Tanah Kosong", value: "tanah kosong" },
    { label: "Pasir", value: "pasir" },
  ],
};

const KOMODITAS = [
  { label: "Bawang Merah", value: "bawang merah", colour: "#ffb077" },
  { label: "Bawang Putih", value: "bawang putih", colour: "#ffe2c5" },
  { label: "Bawang Daun", value: "bawang daun", colour: "#aca586" },
  { label: "Cabe Besar", value: "cabe besar", colour: "#614051" },
  { label: "Cabe Rawit", value: "cabe rawit", colour: "#fdffd5" },
  { label: "Kentang", value: "kentang", colour: "#0000cd" },
  { label: "Kubis", value: "kubis", colour: "#807532" },
  { label: "Tomat", value: "tomat", colour: "#edf5f5" },
  { label: "Kembang Kol", value: "kembang kol", colour: "#738678" },
  { label: "Sawi/Petsai", value: "sawi/petsai", colour: "#cc9966" },
  { label: "Wortel", value: "wortel", colour: "#fcc01e" },
  { label: "Lobak", value: "lobak", colour: "#87ab39" },
  { label: "Gambas", value: "gambas", colour: "#838996" },
  { label: "Kacang Merah", value: "kacang merah", colour: "#e0218a" },
  { label: "Kacang Panjang", value: "kacang panjang", colour: "#4b5d52" },
  { label: "Selada", value: "selada", colour: "#edb381" },
  { label: "Seledri", value: "seledri", colour: "#6f440c" },
  { label: "Paprika", value: "paprika", colour: "#ffff00" },
  { label: "Jamur", value: "jamur", colour: "#d4d7d9" },
  { label: "Terung", value: "terung", colour: "#918151" },
  { label: "Buncis", value: "buncis", colour: "#bdb76b" },
  { label: "Labu Siam", value: "labu siam", colour: "#a4a6d3" },
  { label: "Kangkung", value: "kangkung", colour: "#327c14" },
  { label: "Bayam", value: "bayam", colour: "#483d8b" },
  { label: "Melon", value: "melon", colour: "#163531" },
  { label: "Semangka", value: "semangka", colour: "#ffcc33" },
  { label: "Blewah", value: "blewah", colour: "#fff8d1" },
  { label: "Stroberi", value: "stroberi", colour: "#ffb97b" },
  { label: "Alpukat", value: "alpukat", colour: "#eac674" },
  { label: "Belimbing", value: "belimbing", colour: "#403b38" },
  { label: "Durian", value: "durian", colour: "#bdb2a1" },
  { label: "Jeruk Siam/Keprok", value: "jeruk siam/keprok", colour: "#778899" },
  { label: "Jeruk Besar ", value: "jeruk besar ", colour: "#317873" },
  { label: "Pisang", value: "pisang", colour: "#8b5f4d" },
  { label: "Mangga", value: "mangga", colour: "#b5b35c" },
  { label: "Manggis", value: "manggis", colour: "#009f6b" },
  { label: "Rambutan", value: "rambutan", colour: "#f8c3df" },
  { label: "Nanas", value: "nanas", colour: "#84a0a0" },
  { label: "Apel", value: "apel", colour: "#cec291" },
  { label: "Bengkuang", value: "bengkuang", colour: "#0f52ba" },
  { label: "Anggur", value: "anggur", colour: "#b05c52" },
  { label: "Buah Naga", value: "buah naga", colour: "#ff9e2c" },
  { label: "Duku", value: "duku", colour: "#50c878" },
  { label: "Jahe ", value: "jahe ", colour: "#beb5b7" },
  { label: "Laos/Lengkuas", value: "laos/lengkuas", colour: "#1c352d" },
  { label: "Lempuyang", value: "lempuyang", colour: "#fdff00" },
  { label: "Kencur", value: "kencur", colour: "#782f16" },
  { label: "Kunyit", value: "kunyit", colour: "#ac1e44" },
  { label: "Pembibitan", value: "pembibitan", colour: "#98fb98" },
  { label: "Anggrek", value: "anggrek", colour: "#ffc1cc" },
  { label: "Krisan", value: "krisan", colour: "#9dc209" },
  { label: "Mawar", value: "mawar", colour: "#0b0b0b" },
  { label: "Melati", value: "melati", colour: "#ff8c00" },
  { label: "Sedap Malam", value: "sedap malam", colour: "#4e2a5a" },
  { label: "Matahari", value: "matahari", colour: "#fde1dc" },
  { label: "Karet", value: "karet", colour: "#7ca1a6" },
  { label: "Kelapa", value: "kelapa", colour: "#625119" },
  { label: "Kelapa Sawit", value: "kelapa sawit", colour: "#afeeee" },
  { label: "Kopi", value: "kopi", colour: "#711a00" },
  { label: "Tea", value: "tea", colour: "#646e75" },
  { label: "Cengkeh", value: "cengkeh", colour: "#be4f62" },
  { label: "Lada ", value: "lada ", colour: "#ba55d3" },
  { label: "Kakao", value: "kakao", colour: "#daa520" },
  { label: "Jambu Mete", value: "jambu mete", colour: "#b03060" },
  { label: "Tebu", value: "tebu", colour: "#ff7a00" },
  { label: "Tembakau", value: "tembakau", colour: "#6a442e" },
  { label: "Kapas", value: "kapas", colour: "#734f96" },
  { label: "Nila", value: "nila", colour: "#e1c0c8" },
  { label: "Pala", value: "pala", colour: "#bcc9c2" },
  { label: "Sagu", value: "sagu", colour: "#f3ffd8" },
  { label: "Padi ", value: "padi ", colour: "#fffdf3" },
  { label: "Padi Sawah", value: "padi sawah", colour: "#462425" },
  { label: "Padi Ladang", value: "padi ladang", colour: "#8581d9" },
  { label: "Jagung", value: "jagung", colour: "#002900" },
  { label: "Kedelai", value: "kedelai", colour: "#c84186" },
  { label: "Kacang Tanah", value: "kacang tanah", colour: "#d74894" },
  { label: "Kacang Hijau", value: "kacang hijau", colour: "#b6baa4" },
  { label: "Ubi Kayu", value: "ubi kayu", colour: "#a9ba9d" },
  { label: "Ubi Jalar", value: "ubi jalar", colour: "#9370db" },
  { label: "Porang", value: "porang", colour: "#8fd400" },
  { label: "Lainnya", value: "lainnya", colour: "#696969" },
];

const SIG_TIPE_BASED_BIDANG = [
  "pemanfaatan_tanah",
  "penggunaan_tanah",
  "status_hak",
  "komoditas",
];

const SELECT_LISTS_FILTERED_MAP = {
  penggunaan_tanah: CHOOSE_PENGGUNAAN_TANAH.SELECT,
  pemanfaatan_tanah: PEMANFAATAN_TANAH.pertanian.concat(
    PEMANFAATAN_TANAH["non pertanian"]
  ),
  status_hak: STATUS_HAK.LIST,
  komoditas: KOMODITAS,
};

const UNITS_TYPE = ["panjang", "luas", "jumlah", "Luas", "Panjang", "Jumlah"];

const UNITS = {
  luas: [
    {
      label: "M2",
      value: "M2",
    },
    {
      label: "Ha",
      value: "Ha",
    },
  ],
  panjang: [
    {
      label: "Km",
      value: "Km",
    },
  ],
  jumlah: [
    {
      label: "Keluarga",
      value: "Keluarga",
    },
    {
      label: "Penduduk",
      value: "Penduduk",
    },
    {
      label: "Bidang",
      value: "Bidang",
    },
  ],
};

const FILTER_BIDANG_BY_FIELD = {
  NBT: "nbt",
  KEPEMILIKAN: "pemilik",
  KEPENGUASAAN: "penguasa",
  LISTS: [
    {
      label: "Kepemilikan",
      value: "pemilik",
    },
    {
      label: "Kepenguasaan",
      value: "penguasa",
    },
    {
      label: "NBT",
      value: "nbt",
    },
  ],
};

const TEXTEDITOR_CONFIG = {
  toolbar: {
    items: [
      "|",
      "undo",
      "redo",
      "removeFormat",
      "|",
      "heading",
      "|",
      "fontSize",
      "fontFamily",
      "fontColor",
      "fontBackgroundColor",
      "|",
      "bold",
      "italic",
      "underline",
      "strikethrough",
      "code",
      "subscript",
      "superscript",
      "|",
      "bulletedList",
      "numberedList",
      "|",
      "alignment",
      "indent",
      "outdent",
      "|",
      "link",
      "insertTable",
      "specialCharacters",
      //       'imageUpload',
      "mediaEmbed",
      "htmlEmbed",
      "|",
      "highlight",
      "blockQuote",
      "horizontalLine",
      "pageBreak",
      "|",
      "restrictedEditingException",
    ],
  },
  blockToolbar: [
    "heading",
    "fontSize",
    "fontColor",
    "fontBackgroundColor",
    "alignment",
    "|",
    "bulletedList",
    "numberedList",
    "|",
    "blockQuote",
    //     'imageUpload'
  ],
  fontSize: {
    options: [
      8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 39,
      40, 42, 44, 46, 48, 50, 62, 64, 66, 68, 70, 72,
    ],
  },
  //   image: {
  //     toolbar: [
  //       'imageStyle:alignLeft',
  //       'imageStyle:full',
  //       'imageStyle:alignRight',
  //       '|',
  //       'imageTextAlternative'
  //     ],
  //     styles: ['full', 'side', 'alignLeft', 'alignCenter', 'alignRight']
  //   },
  table: {
    contentToolbar: [
      "tableColumn",
      "tableRow",
      "mergeTableCells",
      "tableProperties",
      "tableCellProperties",
    ],
  },
};

const TIPE_ATRIBUT = {
  INT: "int",
  FLOAT: "float",
  DATE: "date",
  STR: "str",
  LIST: "list",
  IS_DATA: [
    {
      label: "INT",
      value: "int",
    },
    {
      label: "FLOAT",
      value: "float",
    },
    {
      label: "DATE",
      value: "date",
    },
    {
      label: "STR",
      value: "str",
    },
    {
      label: "LIST",
      value: "list",
    },
  ],
};

export {
  KELAINAN_FISIK,
  SELECT_VALUE,
  JENIS_KEPINDAHAN,
  JENIS_KELAMIN,
  DATA_JENIS_KELAMIN,
  API_BASE_URL,
  DATA_BATAS_DAERAH,
  BASE_MAP_ZOOM_LEVEL,
  PETA_PER_PAGE,
  LIST_DATA_LAYER,
  ACTIVE_LAYER,
  DONUT_OPTIONS,
  BAR_OPTIONS,
  SELECT_OPTIONS,
  ROLES,
  SETTINGS_MDE,
  MDE_OPTIONS,
  JENIS_LISTRIK,
  ACTION_LEGENDA,
  OPSI_LEGENDA,
  TIPE_LEGENDA,
  DUMMYLIST_SKAU,
  DUMMYLIST_PEMAKAMAN,
  DUMMYLIST_SKAW,
  DUMMY_LIST_AHLI_WARIS,
  DUMMY_LIST_BAGI_WARISAN,
  REMOVE_USELESS_KEY,
  BIDANG_LAYER,
  TIPE_PETA,
  MEASUREOPTIONS,
  TIPE_WITH_BIDANG,
  HIERARKI_CASE,
  TIPE_LAYER,
  CONFIG_CHART,
  FEATURE_PETA_TEMATIK,
  FIELD_MAPS_WITH_LAYER_BIDANG,
  TIPE_HERO,
  CK_EDITOR_TOOLBAR_GROUP,
  SUB_MENU_PPID,
  DUMMY_LIST_SUBMENU_PPID,
  HTTP_METHOD,
  LOADING_TEXT,
  BASE_MAP,
  CHOOSE_INTEGRASI_BIDANG,
  CHOOSE_PENGGUNAAN_TANAH,
  NOTIF_KEY,
  STATUS_UPLOADING,
  TYPE_LEGEND,
  INITIAL_LEGENDA,
  JENIS_PETA,
  OPTION_SEARCH_PENGUASA,
  STATUS_HAK,
  CREATE_TIPE_METODE,
  DATA_WITH_SIG_RELATIONS,
  SIG_WITH_RELATIONS,
  HIERARKI_MODEL,
  GEOJSON_STYLES,
  HIERARKI_CASE_NAME,
  PALLETE_STYLES,
  LEGEND_KEY,
  PROPERTIES_DRAW_MAP,
  GEOJSON_STYLES_WITH_LAYER_BIDANG,
  DEFAULT_GEOJSON_STYLES,
  TYPE_ORTU,
  HOLLOW_MAP_STYLE,
  PASSWORD_SYMBOL,
  TIPE_PENGUASA,
  PEMANFAATAN_TANAH,
  KOMODITAS,
  SIG_TIPE_BASED_BIDANG,
  SELECT_LISTS_FILTERED_MAP,
  UNITS_TYPE,
  UNITS,
  FILTER_BIDANG_BY_FIELD,
  TEXTEDITOR_CONFIG,
  TIPE_ATRIBUT,
};
